<template>
  <VAppBar
      light
      app
      color="white"
      max-height="52"
      height="52"
      class="header box-shadow-elevation-3 d-flex justify-center"
      :class="!isHeaderShown ? 'is-hidden' : ''"
  >
    <VDialog
        v-if="isLogOutDialogOpen"
        :value="isLogOutDialogOpen"
        width="425"
        persistent
    >
      <LogoutDialog
          :isLoadingLogOut="isLoadingLogOut"
          @logOut="$emit('logOut')"
          @closeDialog="isLogOutDialogOpen = false"
      />
    </VDialog>
    <div class="breakpoint-xl d-flex align-center justify-content-between w-100 px-3">
      <div class="d-flex align-center">
        <slot name="headerLogoIcon">
          <TheHeaderIcon
            :logo="logo"
            :logoRedirectPath="logoRedirectPath"
          >
          <slot />
          </TheHeaderIcon>
        </slot>
        <TheHeaderLinks :toolbarItems="toolbarItems" :showOnClick="showOnClick"/>
      </div>
      <div class="d-flex align-center">
        <TheLanguageSwitcher
            v-if="!!getSupportedLanguages.length && currentLang"
            :currentLang="currentLang"
            :languages="getSupportedLanguages"
            @setLang="setLang"
        />
        <TheCabinetMenu
            v-if="authToken && firstLetters"
            :firstLetters="firstLetters"
            :fullName="fullName"
            :cabinetToolbarItems="cabinetToolbarItems"
            @openLogOutDialog="isLogOutDialogOpen = !isLogOutDialogOpen"
        />
        <slot v-else name="loginButton">
          <TheLoginButton @toAuthPage="toAuthPage" />
        </slot>
      </div>
    </div>
  </VAppBar>
</template>
<script lang="ts">
export default {
  name: 'STheHeader',
};
</script>

<script setup lang="ts">
import { computed, ref } from 'vue';
import TheHeaderLinks from './theHeaderLinks/TheHeaderLinks.vue';
import TheHeaderIcon from './theHeaderIcon/TheHeaderIcon.vue';
import TheLanguageSwitcher from './theLanguageSwitcher/TheLanguageSwitcher.vue';
import TheLoginButton from './theLoginButton/TheLoginButton.vue';
import TheCabinetMenu from './theCabinetMenu/TheCabinetMenu.vue';
import LogoutDialog from './LogoutDialog.vue';

const props = defineProps({
  srcIcon: {
    type: String,
    default: 'logo.svg',
  },
  isLoadingLogOut: {
    type: Boolean,
    default: false,
  },
  currentLang: {
    type: String,
    default: null,
  },
  supportedLanguages: {
    type: Array,
    default: () => [],
  },
  toolbarItems: {
    type: Array,
    default: () => [],
  },
  authToken: {
    type: String,
    default: null,
  },
  firstLetters: {
    type: String,
    default: null,
  },
  fullName: {
    type: String,
    default: null,
  },
  cabinetToolbarItems: {
    type: Array,
    default: () => [],
  },
  showOnClick: {
    type: Boolean,
    default: false,
  },
  logo: {
    type: Object,
    default: null,
  },
  logoRedirectPath: {
    type: Object,
    default: () => ({}),
  },
  isHeaderShown: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['logOut', 'setLang', 'toAuthPage']);

const allLanguages = [
  {
    text: 'Français',
    value: 'fr',
  },
  {
    text: 'Português',
    value: 'pt',
  },
  {
    text: 'Español',
    value: 'es',
  },
  {
    text: 'English',
    value: 'en',
  },
  {
    text: 'Nederlands',
    value: 'nl',
  },
  {
    text: 'Italiano',
    value: 'it',
  },
  {
    text: 'Deutsch',
    value: 'de',
  },
  {
    text: 'Luxembourgian',
    value: 'lu',
  },
];
const isLogOutDialogOpen = ref(false);

const getSupportedLanguages = computed(() => (
  allLanguages.filter(({ value }) => (props.supportedLanguages as any[]).includes(value))
));

function logOut() {
  emit('logOut');
}

function setLang(lang: any) {
  emit('setLang', lang);
}

function toAuthPage() {
  emit('toAuthPage');
}
</script>
<style scoped lang="scss">
</style>
